<product-list
    [products]="products"
    [pagination]="true"
    [config]="config"
    [page]="page"
    [len]="len"
    [total]="total"
></product-list>
